module.exports = __webpack_public_path__ + "static/media/send-letter-file-circle.5e47bee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-file-circle.png
// module id = 596
// module chunks = 1